<template>
    <v-timeline dense>
        <v-timeline-item
                v-for="(employer, i) in employers"
                :key="i"
                :color="employer.color || 'black'"
                small
                :class="'employer_'+employer.companyKey"
        >
            <!--<template v-slot:opposite :class="`${employer.color}&#45;&#45;text`">-->

            <div class="py-3">
                <h2 :class="`headline font-weight-light mb-3 ${employer.color}--text`">

                    <v-layout row>
                        <LinkComponent v-if="employer.companyKey" v-bind:theKey="employer.companyKey"
                                       class="headline font-weight-bold"/>
                        <span :class="`duration ${employer.color}--text`">&nbsp;-&nbsp;{{employer.duration}}
                            <span v-if="i===0"> ({{ongoing}})</span>
                        </span>

                        <v-flex>
                            <div :class="{'employer-skills': true, 'first':i===0}">
                            <span v-for="(skill, ii) in getSkills(employer.missions).skills" v-bind:key="ii">
                                <LinkComponent v-bind:theKey="skill" :displayName="false"/>
                            </span>
                            </div>
                        </v-flex>

                    </v-layout>
                    <div class="capacity">{{employer.capacity}}

                    </div>
                </h2>


                <div v-for="(mission,i) in employer.missions" :key="i" class="mmission">
                    <div class="mmission_title"><b>
                      <LinkComponent v-bind:theKey="mission.companyKey"/>
                          {{mission.companyKey ? '-':''}}</b>
                          {{mission.capacity}}
                      <span class="duration2">({{mission.duration}})</span>
                    </div>
                    <div v-for="(practice,j) in mission.practices" :key="j" class="practice" style="white-space: pre-line">
                        <span class="dot"></span>{{practice}}
                    </div>
                    <span class="keyword" v-if="mission.keywords.length > 0"><span>{{root.keywordsLabel}}</span>:&nbsp;{{formatKeyWords(mission.keywords)}}</span>
                </div>

            </div>
            <div class="date" :class="`${employer.color}--text`">{{employer.startDate}}</div>
        </v-timeline-item>
    </v-timeline>
</template>

<script>
    import LinkComponent from './LinkComponent';

    const skillsLinkKeys = ['js', 'typescript', 'angular2', 'react', 'vuejs', 'nodejs', 'git', 'cs', 'windows', 'linux'];
    const sortWithOrder = (order) => {
        return function (a, b) {
            const indexA = order.indexOf(a);
            const indexB = order.indexOf(b);
            if (indexA < 0 && indexB < 0) return -1;
            if (indexA < 0) return 1;
            if (indexB < 0) return -1;
            return indexA - indexB;
        };
    };

    export default {
        name: 'linkComponent',
        props: ['data'],
        components: {LinkComponent},
        computed: {
          ongoing() {
            return this.$dataService.getAll().ongoing
          }
        },
        methods: {
            formatKeyWords: function (keywords) {
                const myKeywords = this.$dataService.getAll().orderedKeywords;
                return keywords
                    .filter(x => myKeywords.includes(x))
                    .sort(sortWithOrder(myKeywords))
                    .map(k => this.$dataService.getAll().keywords[k])
                    .join(', ');
            },
            // formatDate: function (str = '') {
            //     return str.split(' ').map(x => {
            //         return {txt: x, isNb: /\d/.test(x)}
            //     });
            // },
            getSkills: function (missions) {
                let skills = [];
                missions.forEach(mission => {
                    skills = mission.skillsKeys.concat(skills);
                });
                skills = [...new Set(skills)];
                skills = skills
                    .filter(x => skillsLinkKeys.includes(x))
                    .sort(sortWithOrder(skillsLinkKeys));
                return {
                    skills: [...new Set(skills)]
                }
            }
        },
        data: function () {
            return {
                employers: this.$dataService.getEmployers(),
                root: this.$dataService.getAll(),
            }
        }
    }
</script>

<style lang="scss">
    .v-timeline {
        padding-top: 12px !important;
        .v-timeline-item {
            padding-bottom: 0;

            .v-timeline-item__body {
                .py-3 {
                    padding-top: 0 !important;
                }
            }

            h2 {
            }
        }

        margin-left: 20px;

        .mb-3 {
            margin-bottom: 0 !important;
        }

        h2 {
            .capacity {
                font-size: 15px;
                margin-top: -10px;
                margin-left: 10px;
                justify-content: space-between;
                display: flex;
            }
        }

        .employer-skills {
            border-radius: 3px;
            height: 20px;
            margin-right: 5px;
            display: flex;
            justify-content: flex-end;
            flex-wrap: wrap;
            margin-left: auto;
            &.first {
              max-width: 130px;
            }

            .sprite {
                position: relative;
                top: -3px;
                right: -4px;
            }
        }

        .dates {
            font-size: 13px;
            /*font-style: italic;*/
            .bold {
                font-weight: bold;
                font-size: 20px;
                font-style: normal;
            }
        }

        .date {
            position: absolute;
            left: -68px;
            bottom: -10px;
            background-color: white;
            width: auto;
        }

        .duration {
            font-style: italic;
            color: grey;
            font-size: 13px;
            line-height: 37px;
            height: 30px;
        }

        .duration2 {
            font-style: italic;
            color: grey;
            font-size: 11px;
        }

        .sprite {
            margin-right: 8px;
            top: 2px;
            position: relative;
        }

        .keyword,
        .practice {
            font-size: 12px;
            font-style: italic;
            margin-left: 8px;
            color: #989898;
            line-height: 20px;
        }

        .keyword {
            /*color: grey;*/

            span {
                text-decoration: underline;
                /*font-style: normal;*/
            }
        }

        .dot {
            position: relative;
            top: -3px;
            height: 4px;
            width: 4px;
            background-color: grey;
            border-radius: 50%;
            display: inline-block;
            margin-right: 6px;
        }
    }
</style>
